// extracted by mini-css-extract-plugin
export var lg = "_1j-4";
export var md = "_1j-3";
export var sm = "_1j-2";
export var xs = "_1j-1";
export var xxs = "_1j-0";